import { escapeHtml } from './attributeParsing.js';
import { pdfLabelFor, renderLabeledValuePdfHtml } from './pdf.js';
/** Canonical email shape check, same pattern used across the backend routers. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (raw) => EMAIL_REGEX.test(raw.trim());
const valueAsString = (value) => (typeof value === 'string' ? value.trim() : '');
export const emailInputDescriptor = {
    type: 'email-input',
    surfaces: ['rental-agreement'],
    blockLabel: 'Email Input',
    defaultLabel: 'Enter your email address',
    requiredDefault: true,
    extraAttrs: [],
    valueChannel: 'progress',
    editorPlaceholderHtml: (label) => `<div style="display:flex;align-items:center;gap:10px;pointer-events:none;">
      <span style="font-size:20px;">&#9993;&#65039;</span>
      <div>
        <div style="font-weight:600;font-size:14px;color:#334155;">${escapeHtml(label)}</div>
        <div style="font-size:12px;color:#94a3b8;">Guest enters their email address</div>
      </div>
    </div>`,
    validate: (_field, value) => {
        const str = valueAsString(value);
        if (!str)
            return null;
        return isValidEmail(str) ? null : 'Please enter a valid email address';
    },
    isComplete: (field, value) => {
        const str = valueAsString(value);
        if (!str)
            return !field.required;
        return isValidEmail(str);
    },
    renderPdfHtml: (field, value) => renderLabeledValuePdfHtml(pdfLabelFor(field), escapeHtml(valueAsString(value))),
};
